import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { fmtDate } from "@/lib/utils";

export default function RFQRequests() {
  const [rfqs, setRfqs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/vendor/rfqs").then((r) => setRfqs(r.data));
  }, []);

  return (
    <div className="p-6 md:p-8" data-testid="vendor-rfqs-page">
      <h1 className="text-2xl font-extrabold tracking-tight">RFQ Requests</h1>
      <p className="text-slate-500 text-sm mt-1">Submit quotes for open requests from contractors.</p>

      <div className="overflow-x-auto">
        <table className="w-full mt-7 text-[13px]" data-testid="vendor-rfq-table">
          <thead>
            <tr className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold border-b border-slate-100">
              <th className="text-left py-2.5">RFQ #</th><th className="text-left py-2.5">Title</th><th className="text-left py-2.5">Due</th><th className="text-left py-2.5 pl-3">Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {rfqs.map((r) => (
              <tr key={r.id} onClick={() => navigate(`/vendor/rfqs/${r.id}`)} className="cursor-pointer hover:bg-slate-50 border-b border-slate-50" data-testid={`vendor-rfq-row-${r.rfq_number}`}>
                <td className="py-3 mono text-sky-600 font-medium">{r.rfq_number}</td>
                <td className="py-3">{r.title}</td>
                <td className="py-3 text-slate-500">{r.due_date ? fmtDate(r.due_date) : "—"}</td>
                <td className="py-3 pl-3"><StatusBadge status={r.status} /></td>
                <td className="py-3 text-right text-sky-600 font-semibold text-[12.5px]">{r.status === "open" ? "Quote →" : "View"}</td>
              </tr>
            ))}
            {rfqs.length === 0 && <tr><td colSpan={5} className="py-10 text-center text-slate-400 text-sm">No RFQs yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
